import { render } from "./SignatureVerification.vue?vue&type=template&id=4b31d5eb&ts=true"
import script from "./SignatureVerification.ts?vue&type=script&lang=ts&external"
export * from "./SignatureVerification.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__